import storage from "./common/data.js";
import { puzzleId, todaysPuzzleId, isTodaysPuzzle } from "./common/daily.js";

export function loadState(grid) {
	if (storage.savedState.puzzleId == puzzleId) {
		applySave(storage.savedState.gridState, grid);
		applyUndoStack(storage.savedState.undoStack, grid);
		return;
	}

	if (storage.bestSolutions[puzzleId])
		applySave(storage.bestSolutions[puzzleId].gridState, grid);
}

export function saveState(grid, wallCount, complete) {
	if (isTodaysPuzzle)
		storage.savedState = {
			puzzleId,
			gridState: encodeGridState(grid),
			undoStack: {
				stack: grid.undoStack.map(encodeUndoStackEntry),
				pointer: grid.undoPointer
			}
		};

	const current = storage.bestSolutions[puzzleId];
	if (complete && (!current || wallCount <= current.wallCount))
		storage.bestSolutions = {
			...storage.bestSolutions,
			wallCount: undefined,
			gridState: undefined,
			[puzzleId]: {
				wallCount,
				gridState: encodeGridState(grid)
			}
		};
}

function encodeGridState(grid) {
	let encoding = '1';
	for (const row of grid.cells.slice(1))
		for (const cell of row.slice(1)) {
			if (cell.xyParity) continue;
			if (cell.vWall) encoding += 'v';
			else if (cell.hWall) encoding += 'h';
			else encoding += '-';
		}
	return encoding;
}

function encodeUndoStackEntry(entry) {
	let encoding = '1';
	for (let y = 1; y < entry.length; ++y)
		for (let x = 1 + (y & 1); x < entry[y].length; x += 2) {
			const [vWall, hWall] = entry[y][x];
			if (vWall) encoding += 'v';
			else if (hWall) encoding += 'h';
			else encoding += '-';
		}
	return encoding;
}

function applySave(state, grid) {
	const values = [...state];
	switch (values.shift()) {
		case '1':
			for (const row of grid.cells.slice(1))
				for (const cell of row.slice(1)) {
					if (cell.xyParity) continue;
					switch (values.shift()) {
						case 'v': cell.vWall = grid.cells[cell.y - 1][cell.x].vWall = true; break;
						case 'h': cell.hWall = grid.cells[cell.y][cell.x - 1].hWall = true; break;
						case '-': break;
						default: console.warn("unexpected save state token in " + state);
					}
				}
			break;
		default:
			console.warn("unexpected save state format in " + state);
			return;
	}
	grid.update(false);
}

function applyUndoStack({ stack, pointer }, grid) {
	grid.undoPointer = pointer;
	grid.undoStack = stack.map(entry => {
		const values = [...entry]
		switch (values.shift()) {
			case '1':
				const e = grid.cells.map(row => row.map(cell => [false, false]));
				for (const row of grid.cells.slice(1))
					for (const cell of row.slice(1)) {
						if (cell.xyParity) continue;
						switch (values.shift()) {
							case 'v': e[cell.y][cell.x][0] = e[cell.y - 1][cell.x][0] = true; break;
							case 'h': e[cell.y][cell.x][1] = e[cell.y][cell.x - 1][1] = true; break;
							case '-': break;
							default: console.warn("unexpected save state token in " + state);
						}
					}
				return e;
			default: throw new Error("Unexpected undo format in " + entry);
		}
	});
}
